/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { ModuloTypes } from '../../@types/entities/modulo.entity';
import getModulesType from '../../utils/get-Modules-Types';

interface propTypes {
  $modulo: ModuloTypes
  $color: 10 | 20 | 30 | 40 | 50;
}

export const Button = styled.button<propTypes>`
    position: relative;
    bottom: 80px;
    margin-left: auto;
    padding: 16px 24px;
    border-radius: 12px 0px 0px 12px;
    border: none;
    cursor: pointer;
    background: ${({ theme, $modulo, $color }) => getModulesType({ modulo: $modulo, color: $color, theme })};
    color: ${({ theme }) => theme.colors.grayscale[20]};
    transition: .3s ease;
    opacity: 1;
    &:hover{
        background: ${({ theme, $modulo }) => getModulesType({ modulo: $modulo, color: 40, theme })};
    }

  @media (max-width: 600px) {
    bottom: 120px;
  }
`;
